import React, { FC, useEffect, useState } from 'react';

import { Box } from '@chakra-ui/react';
import { isEmpty, map } from 'lodash';
import { useSelector } from 'react-redux';

import formatNumber from 'components/DataDisplay/Utils/formatNumber';
import { PieChart } from 'components/Visualization';
import { DashboardWidget } from 'components/Visualization/CDashboard/Widget/DashboardWidget';
import { useEnvironmentOptions } from 'containers/App/hooks/useEnvironmentOptions';
import { selectBlueprints } from 'containers/PolicyHub/Blueprints/selectors';

export const ViolationsByEnvironments: FC = () => {
  const { violationsByEnvironments, blueprints } = useSelector(
    selectBlueprints,
  );
  const [data, setData] = useState<any>();
  const { environmentMapping } = useEnvironmentOptions();

  useEffect(() => {
    if (violationsByEnvironments.data) {
      setData(
        map(violationsByEnvironments.data, o => ({
          name: environmentMapping?.[o.environment_id]?.name,
          value: o.failed,
        })),
      );
    }
  }, [violationsByEnvironments.data, environmentMapping]);

  return (
    <DashboardWidget
      label="Policy Violations by Environments"
      content={
        <Box w="full" h="full">
          <PieChart
            isLoading={
              violationsByEnvironments.isLoading || blueprints.isLoading
            }
            data={data}
            dataKey="value"
            total={formatNumber(
              data?.reduce((s, el) => s + el?.value || 0, 0),
              1,
            )}
            activeShape={false}
            outerRadius="94%"
            innerRadius="84%"
            styles={{
              pie: { cx: isEmpty(data) ? '50%' : '47%' },
              legend: {
                wrapperStyle: {
                  width: '40%',
                },
              },
            }}
          />
        </Box>
      }
      styles={{ contentWrapper: { px: 0, pt: 0, pb: 1 } }}
    />
  );
};
